import React, { useState, useCallback } from 'react';

import { Typography, IconButton, Menu, MenuItem } from '@material-ui/core';
import { MoreVert } from '@material-ui/icons';
import { isFunction, isEmpty, isEqual, isUndefined, find } from 'lodash';
import PropTypes from 'prop-types';

import { t } from '~/helpers';

import * as S from './styles';

export default function Card({
  detach,
  labels,
  data,
  permission,
  actions,
  onEdit,
  onDelete,
  onSelect,
  update,
  delete: CRUDDelete,
}) {
  const [anchorEl, setAnchorEl] = useState(null);

  const handleOpen = useCallback(({ currentTarget }) => {
    setAnchorEl(currentTarget);
    onSelect();
  }, []);

  const isData = find(labels, (label) => label.id === detach);

  return (
    <S.Wrapper onClick={onSelect}>
      <header>
        <Typography color="primary" variant="h5">
          {isData && isFunction(isData.formatted)
            ? find(labels, (label) => label.id === detach).formatted(
                data[detach]
              )
            : data[detach]}
        </Typography>

        {(update || CRUDDelete || !isEmpty(actions)) && (
          <IconButton aria-label="filtro" onClick={handleOpen}>
            <MoreVert />
          </IconButton>
        )}
      </header>

      <Menu
        keepMounted
        id="menu"
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={() => setAnchorEl(null)}
      >
        {(permission.update || isEqual(permission, { read: true })) &&
          (isUndefined(labels.onUpdate) || labels.onUpdate(data)) &&
          update && (
            <MenuItem onClick={() => onEdit()}>
              {t(
                isEqual(permission, { read: true })
                  ? 's.geral.botaomodelo'
                  : 's.geral.botaoalterar'
              )}
            </MenuItem>
          )}

        {permission.delete &&
          (isUndefined(labels.onDelete) || labels.onDelete(data)) &&
          CRUDDelete && (
            <MenuItem onClick={() => onDelete()}>
              {t('s.geral.botaoexcluir')}
            </MenuItem>
          )}

        {actions.map((action, index) => (
          <MenuItem
            key={`menu-item-${index}`}
            onClick={() => action.action(data)}
          >
            {action.title}
          </MenuItem>
        ))}
      </Menu>

      {labels
        .filter((label) => label.id !== detach)
        .map(({ label, id, formatted }) => (
          <S.Label>
            <Typography variant="caption">{label}</Typography>
            <Typography variant="body1">
              {isFunction(formatted) ? formatted(data[id]) : data[id]}
            </Typography>
          </S.Label>
        ))}
    </S.Wrapper>
  );
}

Card.propTypes = {
  detach: PropTypes.string.isRequired,
  labels: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      label: PropTypes.string,
    })
  ).isRequired,
  data: PropTypes.arrayOf(PropTypes.any).isRequired,
  permission: PropTypes.shape({
    update: PropTypes.bool,
    delete: PropTypes.bool,
  }).isRequired,
  actions: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string.isRequired,
      icon: PropTypes.element.isRequired,
      action: PropTypes.func.isRequired,
      color: PropTypes.oneOf(['primary', 'secondary', 'default']),
      disabled: PropTypes.bool,
    })
  ).isRequired,
  onEdit: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
  onSelect: PropTypes.func.isRequired,
  update: PropTypes.bool.isRequired,
  delete: PropTypes.bool.isRequired,
};
